mutation Signup (
    $firstName: String!
    $lastName: String!
    $email: String!
    $fieldsOfInterest: [String]
    $isMedicalProfessional: Boolean,
    $newsletter: Boolean
) {
    signup(
        first_name: $firstName
        last_name: $lastName
        email: $email
        fieldsOfInterest: $fieldsOfInterest
        isMedicalProfessional: $isMedicalProfessional
        newsletter: $newsletter
    ) {
        status
        message
    }
}
